module.exports = __webpack_public_path__ + "static/media/amz_RIGHT_VIEW_07.0385b638.svg";